import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerAdmin } from "../../services/NewsService";
import "../../styles/Login.css";

function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setIsLoading(true);
    try {
      await registerAdmin(email, password);
      setMessage("Admin created successfully!");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data ||
          "Registration failed",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Add Admin User</h2>
        {message && <div className="success">{message}</div>}
        {error && <div className="error">{error}</div>}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Creating..." : "Create Admin"}
        </button>
        <button
          type="button"
          onClick={() => navigate("/")}
          style={{ background: "#6c757d", marginTop: "0.5rem" }}
        >
          Cancel
        </button>
      </form>
    </div>
  );
}

export default Register;
